
import ProductTile from '@/components/ProductTile'
import HeroButton from '@/components/HeroButton'

export default {
  components: {
    ProductTile,
    HeroButton,
  },
  data() {
    return {
      acuvueProducts: [
        {
          link: '/acuvue/daily-disposables/1-day-acuvue-moist_p13',
          image: {
            path: 'productsMain/13-1-day-acuvue-moist-front.jpg',
            alt: '1 Day Acuvue Moist 30 Lenses',
          },
          name: '1-DAY ACUVUE® MOIST',
        },
        {
          link: '/acuvue/daily-disposables/acuvue-oasys-1-day_p458',
          image: {
            path: 'productsMain/458-acuvue-oasys-1-day-front.jpg',
            alt: 'acuvue oasys 1 day',
          },
          name: 'ACUVUE® OASYS® 1-DAY With HydraLuxe™ TECHNOLOGY',
        },
        {
          link: '/acuvue/daily-disposables/acuvue-oasys-1-day-for-astigmatism_p468',
          image: {
            path: 'productsMain/468-acuvue-oasys-1-day-for-astigmatism-front.jpg',
            alt: 'ACUVUE OASYS 1 Day for Astigmatism',
          },
          name: 'ACUVUE OASYS® 1-DAY For ASTIGMATISM With HydraLuxe® Technology',
        },
        {
          link: '/acuvue/multifocal-lenses/1-day-acuvue-moist-multifocal_p250',
          image: {
            path: 'productsMain/250-1-day-acuvue-moist-multifocal-front.jpg',
            alt: '1 Day ACUVUE Moist Multifocal',
          },
          name: '1-DAY ACUVUE® MOIST Multifocal',
        },
        {
          link: '/acuvue/extended-wear-lenses/acuvue-oasys_p38',
          image: {
            path: 'productsMain/38-acuvue-oasys-front.jpg',
            alt: 'acuvue oasys',
          },
          name: 'ACUVUE OASYS® 2-WEEK With HYDRACLEAR® PLUS',
        },
        {
          link: '/acuvue/monthly-disposables/acuvue-vita_p474',
          image: {
            path: 'productsMain/474-acuvue-vita-front.jpg',
            alt: 'ACUVUE Vita',
          },
          name: 'ACUVUE® VITA®',
        },
      ],
    }
  },
  methods: {
    goToDaily() {
      this.$router.push('/acuvue-brand/daily-disposable')
    },
    goToAstigmatism() {
      this.$router.push('/acuvue-brand/astigmatism')
    },
    goToEyeCare() {
      window.open('https://www.lenstore.co.uk/eyecare/six-simple-ways-to-protect-your-eyes-as-you-age', '_blank')
    },
    goToOasysMax() {
      this.$router.push(this.$getLink('/product/559'))
    },
    goToReusable() {
      this.$router.push('/acuvue-brand/reusable-lenses')
    },
    goToPresbyopia() {
      this.$router.push('/acuvue-brand/presbyopia')
    },
    navigate(product) {
      this.$router.push(product.link)
    },
  },
}
